export default "__VITE_ASSET__BN6dYCq0__"